import React, { useState } from "react";
import { Tag, Modal, Timeline, Input } from "antd";
import DataTable from '@/components/DataTable';
import MainCard from '@/components/MainCard';
import { useMbmrAlias } from '@/hooks/useAppSetting';

const PackagingLogs = () => {
  const mbmrAlias = useMbmrAlias();
  const [visible, setVisible] = useState(false);
  const [workflowData, setWorkflowData] = useState([]);
  const [searchText, setSearchText] = useState("");

  const statusColors = {
    Pending: "volcano",
    "In Progress": "blue",
    "QC Check": "purple",
    "Ready to Pack": "green",
    Dispatched: "cyan",
  };

  const logsData = [
    {
      key: "1",
      batchId: "B001",
      product: "Paracetamol",
      createdDate: "2024-03-28 10:00 AM",
      status: "Pending",
      workflow: [
        {
          step: "Raw materials received",
          time: "2024-03-28 10:00 AM",
          completed: true,
        },
        {
          step: "Material checked",
          time: "2024-03-28 11:30 AM",
          completed: false,
        },
      ],
    },
    {
      key: "2",
      batchId: "B002",
      product: "Ibuprofen",
      createdDate: "2024-03-28 09:00 AM",
      status: "In Progress",
      workflow: [
        {
          step: "Raw materials received",
          time: "2024-03-28 09:00 AM",
          completed: true,
        },
        {
          step: "Material checked",
          time: "2024-03-28 10:00 AM",
          completed: true,
        },
        {
          step: "Packaging started",
          time: "2024-03-28 01:00 PM",
          completed: false,
        },
      ],
    },
    {
      key: "3",
      batchId: "B003",
      product: "Aspirin",
      createdDate: "2024-03-28 08:00 AM",
      status: "QC Check",
      workflow: [
        {
          step: "Raw materials received",
          time: "2024-03-28 08:00 AM",
          completed: true,
        },
        {
          step: "Material checked",
          time: "2024-03-28 09:00 AM",
          completed: true,
        },
        {
          step: "Packaging started",
          time: "2024-03-28 12:00 PM",
          completed: true,
        },
        {
          step: "Under quality inspection",
          time: "2024-03-28 02:30 PM",
          completed: false,
        },
      ],
    },
    {
      key: "4",
      batchId: "B004",
      product: "Amoxicillin",
      createdDate: "2024-03-28 07:30 AM",
      status: "Ready to Pack",
      workflow: [
        {
          step: "Raw materials received",
          time: "2024-03-28 07:30 AM",
          completed: true,
        },
        {
          step: "Material checked",
          time: "2024-03-28 08:30 AM",
          completed: true,
        },
        {
          step: "Packaging started",
          time: "2024-03-28 11:00 AM",
          completed: true,
        },
        {
          step: "Under quality inspection",
          time: "2024-03-28 02:00 PM",
          completed: true,
        },
        {
          step: "Approved for packing",
          time: "2024-03-28 03:30 PM",
          completed: false,
        },
      ],
    },
    {
      key: "5",
      batchId: "B005",
      product: "Ciprofloxacin",
      createdDate: "2024-03-28 06:30 AM",
      status: "Dispatched",
      workflow: [
        {
          step: "Raw materials received",
          time: "2024-03-28 06:30 AM",
          completed: true,
        },
        {
          step: "Material checked",
          time: "2024-03-28 07:30 AM",
          completed: true,
        },
        {
          step: "Packaging started",
          time: "2024-03-28 10:00 AM",
          completed: true,
        },
        {
          step: "Under quality inspection",
          time: "2024-03-28 01:00 PM",
          completed: true,
        },
        {
          step: "Approved for packing",
          time: "2024-03-28 03:00 PM",
          completed: true,
        },
        {
          step: "Final dispatch",
          time: "2024-03-28 05:00 PM",
          completed: true,
        },
      ],
    },
  ];

  const handleStatusClick = (workflow) => {
    setWorkflowData(workflow);
    setVisible(true);
  };
  const filteredData = logsData?.filter(
    (item) =>
      item.batchId.toLowerCase().includes(searchText.toLowerCase()) ||
      item.product.toLowerCase().includes(searchText.toLowerCase())
  );
  const columns = [
    { title: `${mbmrAlias} Batch No.`, dataIndex: "batchId", key: "batchId" },
    { title: "Product", dataIndex: "product", key: "product" },
    { title: "Created Date", dataIndex: "createdDate", key: "createdDate" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, record) => (
        <Tag
          color={statusColors[status]}
          onClick={() => handleStatusClick(record.workflow)}
          style={{ cursor: "pointer" }}
        >
          {status}
        </Tag>
      ),
    },
  ];

  return (
    <MainCard title="Execution Log">
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginBottom: 2,
            marginTop: -40,
          }}
        >
          <Input.Search
            placeholder="Search by Batch ID or Product"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 250 }}
          />
        </div>
        <DataTable
          columns={columns}
          data={filteredData}
          pagination={{ pageSize: 5 }}
          bordered
          height={null}
        />
        <Modal
          title="Workflow"
          open={visible}
          onCancel={() => setVisible(false)}
          footer={null}
        >
          <Timeline>
            {workflowData.map((item, index) => (
              <Timeline.Item
                key={index}
                color={item.completed ? "green" : "gray"}
              >
                {item.time} - {item.step}
              </Timeline.Item>
            ))}
          </Timeline>
        </Modal>
      </div>
    </MainCard>
  );
};

export default PackagingLogs;
